var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGotoback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110.358,
    height: 105.359,
    viewBox: "0 0 110.358 105.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c9ddef;}.b{fill:#004f92;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-633.642 -335.641)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 49,
    cy: 49,
    r: 49,
    transform: "translate(646 343)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156.824 138.864)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M526.569,196.777a49.75,49.75,0,1,0,49.751,49.749A49.807,49.807,0,0,0,526.569,196.777Zm0,93.358a43.608,43.608,0,1,1,43.609-43.609A43.659,43.659,0,0,1,526.569,290.135Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M522.245,227.119V216.378a9.821,9.821,0,0,0-9.812-9.81h-5.582a9.82,9.82,0,0,0-9.81,9.81v2.373a3.071,3.071,0,0,0,6.142,0v-2.373a3.671,3.671,0,0,1,3.668-3.668h5.582a3.672,3.672,0,0,1,3.67,3.668v10.714H497.309a8.884,8.884,0,0,0-8.871,8.874v13.119a8.882,8.882,0,0,0,8.871,8.874h24.663a8.885,8.885,0,0,0,8.876-8.874V235.965A8.87,8.87,0,0,0,522.245,227.119Zm2.462,21.966a2.736,2.736,0,0,1-2.734,2.732H497.309a2.735,2.735,0,0,1-2.729-2.732V235.965a2.735,2.735,0,0,1,2.729-2.732h24.663a2.736,2.736,0,0,1,2.734,2.732Z",
    transform: "translate(16.927 14.263)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoback);
export default __webpack_public_path__ + "static/media/gotoback.c8288773362ac9246efeae4fce47bad0.svg";
export { ForwardRef as ReactComponent };